import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  activePage: "Map",
  language: "ar",
  userCredentials: null,
  isLoggedIn: false,
  alert: {
    isAlert: false,
    alertMsg: "",
  },
};
export const appSettingsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_ACTIVE_PAGE:
      return { ...state, activePage: payload };
    case ActionTypes.SET_ACTIVE_LANGUAGE:
      return { ...state, language: payload };
    case ActionTypes.SET_USER_CREDENTIALS:
      return {
        ...state,
        userCredentials: payload.data,
        isLoggedIn: payload.flag,
      };
    case ActionTypes.SET_ALERT:
      return {
        ...state,
        alert: payload,
      };
    default:
      return state;
  }
};
